import React from "react";
import Navigation from "../../Module/Navigation";
import ambadas from "./ambadas.jpg";
import anant from "./anant.jpg";
import hvpm1 from "./hvpm1.jpg"
import hvpm2 from "./hvpm2.jpg"


function History() {
  return (<>
<Navigation/>

  
    <div className="container" style={{ marginBottom: '20px' }}>
      <div className="row">
        <div className="content-area " style={{ display: 'flex', justifyContent: 'space-between' }}>
          {/* <h2 className="vc_custom_heading">Beginning and Background</h2> */}
          <div className="col-sm-3" style={{ padding: '0 10px' }}>
            <h2 className="history-h2">Shri Ambadas Krishna Vaidya</h2>
            <img
              src={ambadas}
              alt=""
              style={{ width: '100%', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', }}
              className="founder-img"
            />
          </div>
          <div className="col-sm-4"></div>
          <div className="col-sm-3" style={{ padding: '0 10px' }}>
            <h2 className="history-h2"> Shri Anant Krishna Vaidya</h2>
            <img
              src={anant}
              alt=""
              style={{ width: '100%', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}
              className="founder-img"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="container" style={{ marginBottom: '20px' }}>
      <div className="row">
        <div className="col-sm-12">
          <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
            Shree Hanuman Vyayam Prasarak Mandal, Amravati was founded by the Vaidya
            Brothers namely Anant Krishna and Ambadas Krishna in the year 1914, as a
            small Hanuman club. The Vaidya brothers may be rightly regarded as the
            pioneer organizers of the movement of physical education in Vidarbha
            Region. The small club thus founded by them half a century ago has now
            come to be recognized as a National Institution which has also earned some
            international reputation. When this club was founded, there was a general
            apathy for physical education. In those times the traditional institutions
            i.e. Akhadas were viewed with suspicion as places of anti-British
            revolutionary movement. The Vaidya brothers while founding the Hanuman
            Club had 2 clear objectives in view. One was to link up the movement of
            physical education with the national movement of Indian renaissance and
            the second was to modernize and systematize the traditional Indian system
            of exercises in such a way as would bring in bold relief the best and
            knowledgeable elements inherent in it. They had a broad and open mind and
            hence were also anxious to incorporate into the old Indian system elements
            from the Western methods and systems of physical education and recreation.
          </p>
        </div>
      </div>
    </div>
    <div className="container" style={{ marginBottom: '20px' }}>
      <div className="row">
        <div className="">
          <h2 className="history-h2">Transformation into Mandal:</h2>
        </div>
        <div className="col-sm-6" style={{ padding: '0 10px' }}>
          <img
            src={hvpm1}
            alt=""
            style={{ width: '100%', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}
            className="founder-img"
          />
        </div>
        <div className="col-sm-6" style={{ padding: '0 10px' }}>
          <img
            src={hvpm2}
            alt=""
            style={{ width: '100%', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}
            className="founder-img"
          />
        </div>
      </div>
    </div>

    <div className="container" style={{ marginBottom: '20px' }}>
      <div className="row">
        <div className="col-sm-12 content-area">
          <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
            When Hanuman club was founded the time was not propitious for propagating
            its cause openly. For some time, it had to be conducted in a secret manner
            until it grew into a big institution, which could come into the open. The
            First World War had ended in the success of the British Government and some
            liberal reforms were introduced in the political and social life of India.
            It was, therefore, in 1918-19 that the Hanuman Club was renamed as The
            Hanuman Vyayam Mandir which could openly spread its activities among the
            youths of Amravati as well as those coming from other places to Amravati
            for educational purposes. In short time, the daily attendance went up from
            150 to 450. Several youths trained, went back in course of time to their
            respective places and began to organize gymnasiums on the lines of the
            training, they had received. This development further necessitated
            reorganization of the Hanuman Vyayam Mandir into Shree Hanuman Vyayam
            Prasarak Mandal, which virtually means a body devoted to the organization
            of gymnastic institutions. Hanuman is mythological deity of India devoted
            not only to health and strength but is the very incarnation of ideal
            health, strength, character and intelligence. This ideal was, therefore,
            imbued in the very name of the organization.
          </p>
        </div>
      </div>
    </div>




    <div className="container" style={{ marginBottom: '20px' }}>
      <div className="row">
        <div className="col-sm-12">
          <h4 className="Special" style={{ fontWeight: 'bold' }}>Success and Ventures:</h4>
          <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
            The efficacy and elegance of Mandal’s students was tested in various gymnastic tournaments.
            In the year 1925 when Central Province and Berar Olympic Meets were held at the District Head Quarters of
            Yeotmal where provincial Olympic authorities allowed competitions to be held in India’s traditional games and exercises.
            In this meet young athletes of Mandal secured most of honours and suddenly got a spurt of high reputation.
            This success encouraged the organizers of the Mandal to launch a new scheme of popularizing these exercises and games on a country-wide basis,
            so the idea of summer vacation classes of physical training was devised implemented. These classes are being run every year almost uninterruptedly since 1925.
          </p>

          <h4 className="Special" style={{ fontWeight: 'bold' }}>History of Sport in India:</h4>
          <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
            The history of Indian traditional sports and games can be traced back to the Vedic age. During the era of Ramayana & Mahabharata, around 1900 BC – 7000 BC, men of status & honor were expected to be competitive in sports. During Vedic India, dehvada or the body-way is defined as “one of the ways to full realization”. In times of Rig-Veda, Ramayana, and Mahabharata, the men of stature and circumstance got competent with each other in chariot-racing, archery, horsemanship, military tactics, wrestling, weight-lifting, swimming and hunting. The history also shows from the time of Indus Valley civilization. Indians were one of the most modern and developed civilizations in the ancient period.

            India has several traditional games and sports,some of which have been played for thousands of years.Many of these games do not require much equipment or playing space. Some traditional Indian games are only played in certain regions of India, or may be known by different names and played under different rules and regulations in different regions of the country. Traditional Indian games served various purposes throughout and had various connections to Indian history; for example, Mallakhamba, chariot-racing, archery, horsemanship, military tactics, wrestling, weight-lifting, swimming and hunting etc.

            Torches Marching
            Shri Hanuman Vyam Prasarak Mandal Amravati was established in 1914. Guruvarya Ambadaspant Vaidya and shree Anant Krushna Vaidya established Akhadaas. At that time India was ruled by the British. For that reason, his main objective at that time was to make the young generation of India prosperous and strong to participate in the freedom struggle and to awaken patriotism among them. For that purpose they were to exercise and teach the art of weapons for personal protection.

            At that time, Indian exercise types such as Dandabaithka, SuryaNamaskar, Wrestling, Mallakhamb, etc. were done by him. Also, they were given technical training in the use of weapons such as Lathi , dandapatta, Dhal- Talwar, Vita Bhala, Parshu, etc. At the same time, police training camp was conducted by them military tactics, physical exercises and disciplined exercises. Indian traditional games were also taught here. Accordingly, seeing the enthusiasm of the students and their interest in teaching, some courses were started by his institution. It includes Vyayam Pravesh, Vyayam Patu, Vyayam Visharad among students Lezim, Javelin, Dumbbells, Wends, Jodi, as well as Samtola, Dandabaithka, Lathi- Kathi, Baneti, Dandapatta, Bhala, Madu, Dhal- Talwar , Gadga-Fari, Parshu, etc. Artistic sports were taught. And even today, regular lessons are given in the Mandal, Every Morning and Evening regularly going on. and many students learned the skills of Indian traditional sports and games.
          </p>

        </div>
      </div>
    </div>



  </>)
}
export default History;